import { CSSProperties, FC, SVGProps } from 'react'

import { createStyles } from 'antd-style'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SvgMap = Record<string, FC<SVGProps<SVGSVGElement>> | any>

const assets: SvgMap = import.meta.glob('./assets/*.svg', {
  eager: true,
  import: 'default',
  query: '?react',
})
type IconType =
  | 'applepodcasts'
  | 'facebook'
  | 'google'
  | 'instagram'
  | 'spotify'
  | 'telegram'
  | 'youtube'
  | 'compare'
  | string

const useStyles = createStyles(({ token, css }) => ({
  icon: css`
    padding: 0;
    line-height: 1;
    display: flex;
    color: ${token.colorLink};
  `,
}))

const SvgIcon: FC<Partial<{ style: CSSProperties; size: number; Component: FC<SVGProps<SVGSVGElement>> }>> = ({
  Component,
  style,
  size = 16,
  ...props
}) => {
  const { styles } = useStyles()
  if (!Component) return null
  return (
    <span className={styles.icon} style={{ fontSize: size, ...style }} {...props}>
      <Component width={'1em'} height={'1em'} {...props} />
    </span>
  )
}

const Icon: FC<Partial<{ style: CSSProperties; size: number }> & { type: IconType }> = ({ style, size, type }) => {
  return <SvgIcon Component={assets[`./assets/${type}.svg`]} style={style} size={size} />
}

export { Icon }
